/** Порядок чипсов фильтров (общая строковая карта — экскурсии и туры). */
export const FILTER_ORDER: Record<string, number> = {
  date: 0,
  toursActivities: 1,
  movementTypes: 2,
  type: 3,
  tourFormat: 4,
  price: 5,
  duration: 6,
  comfort_type: 7,
  accommodation_type: 8,
  activity_level_category: 9,
  startTimeInterval: 10,
  childrenAllowed: 11,
  durationInterval: 12,
  tag__slugs: 13,
  selected_rubric: 14,
  sorting: 15,
};

export const CHIP_VALUE_TO_FILTER_KEY: Record<string, string> = {
  date: 'date',
  format: 'type',
  movement: 'movementTypes',
  toursActivities: 'toursActivities',
  price: 'price',
  duration: 'duration',
  startInterval: 'startTimeInterval',
  comfort_type: 'comfort_type',
  activity_level_category: 'activity_level_category',
  accommodation_type: 'accommodation_type',
  children: 'childrenAllowed',
  durationInterval: 'durationInterval',
  chip: 'tag__slugs',
};
